export const getSupportUrl = (isPamUser: boolean, region: string) => {
  if (isPamUser) {
    return `${process.env.REACT_APP_HOST}/support/services`;
  }

  return region === 'UK'
    ? 'https://www.mind.org.uk/information-support/types-of-mental-health-problems/mental-health-problems-introduction/useful-contacts'
    : 'https://findahelpline.com';
};
